import styled from 'styled-components';

const Label = styled.span`
   font-weight: bold;
   font-size: 1.2em;
   margin-right: 4px;
   color: ${({ theme }) => theme.primaryBlueDark};
   ::after {
      content: ':';
   }
`;

export default Label;
